import React from "react";

interface PipelineData {
  pipeline_id : number;
  cdd_name: string;
  client_id : number;
  role : string;
  revenue: string;
  processed_date: string; 
  status: number;
  notes: string;
  projected_start_date: string; 
  client_name: string;
  career_level: string;
  cdd_num: string;
  add_candidates_or_switch_roles: string;
  last_update : string;
}

interface modalProps {
    pipeline : PipelineData[];
}

const CalculateRevenue : React.FC<modalProps> = ({ pipeline }) => {
    return(
        <div>
            <div className="my-2">
                <h2 className="uppercase font-semibold text-gray-700">
                    Total Revenue (Onboarded and Offer Accepted)
                </h2>
            </div>
            <div className="flex flex-col gap-3 my-4">
                <div>
                    <h3 className="uppercase text-gray-700 font">
                        Onboarded:
                    </h3>
                    <h1 className="text-3xl text-gray-600 font-bold">
                        {parseFloat(
                            pipeline.filter(pipe => pipe.status === 6)
                            .reduce((sum, item) => sum + (isNaN(parseFloat(item.revenue)) ? 0 : parseFloat(item.revenue)), 0)
                            .toString()).toLocaleString("en-US", {minimumFractionDigits : 2, maximumFractionDigits : 2})
                        }
                    </h1>
                </div>
                <div>
                    <h3 className="uppercase text-gray-700">
                        Offer Accepted:
                    </h3>
                    <h1 className="text-3xl text-gray-600 font-bold">
                        {parseFloat(
                            pipeline.filter(pipe => pipe.status === 5)
                            .reduce((sum, item) => sum + (isNaN(parseFloat(item.revenue)) ? 0 : parseFloat(item.revenue)), 0)
                            .toString()).toLocaleString("en-US", {minimumFractionDigits : 2, maximumFractionDigits : 2})
                        }
                    </h1>
                </div>
            </div>
        </div>
    )
}

export default CalculateRevenue;